import { createI18n } from 'vue-i18n'
import enUS from './en-US'
import zhCN from './zh-CN'

export const normalizeLocale = (lang) => {
  const value = Array.isArray(lang) ? lang[0] : lang
  const normalized = String(value || '').trim().toLowerCase()
  return normalized === 'en' || normalized.startsWith('en-') ? 'en-US' : 'zh-CN'
}

const queryLang = new URLSearchParams(window.location.search).get('lang')
const initialLocale = normalizeLocale(queryLang || localStorage.getItem('lang'))
localStorage.setItem('lang', initialLocale)

const i18n = createI18n({
  legacy: false, // 必须设置为false，支持组合式API
  locale: initialLocale,
  fallbackLocale: 'zh-CN',
  messages: {
    'en-US': enUS,
    'zh-CN': zhCN
  }
})

export default i18n
